import { useQuery } from "react-query";
import { SnackbarContext } from "../../hooks/SnackbarContext";
import { useContext } from "react";
import { getStoreDetails } from "../../services/StoreService";

export const useStoreDetails = (storeNumber: string, contractDriver: boolean = false) => {
  const { addSnack } = useContext(SnackbarContext);

  return useQuery(
    ["storeDetails", storeNumber],
    () => getStoreDetails(storeNumber),
    {
      enabled: !!storeNumber && !contractDriver,
      refetchOnWindowFocus: false,
      onError: (_err: any) => {
        addSnack({
          severity: "error",
          message: `Error fetching store details`,
          duration: 3000,
        });
      },
      onSuccess: (data) => {
        if (!data || typeof data.companyOwnedFlag === "undefined") {
          addSnack({
            severity: "warning",
            message: "Unexpected store details response",
            duration: 3000,
          });
        }
      },
      retry: (failureCount, error: any) =>
        failureCount < 3 && error?.status === 500,
      staleTime: 300000,
    }
  );
};
